import { render, staticRenderFns } from "./OptionTrades.vue?vue&type=template&id=b70600c0&"
import script from "./OptionTrades.vue?vue&type=script&lang=ts&"
export * from "./OptionTrades.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports